export default "__VITE_ASSET__efb88962__"